import { gql } from "graphql-request";

export const projectPermissions = {
  getProjectPermissions: gql`
    query ProjectPermissions($projectId: String!, $orgType: TenantType!) {
      projectPermissions(projectId: $projectId, orgType: $orgType) {
        canAssignUserAccountToProject
        canAssignUserAccountRoleType
        canEditProjectMembers
        canChangeProjectMembersStatus
        canCreateNewProject
        canChangeProjectStatus
        canEditHADecisionData
        canEditProjectInformation
        canEditParticipationType
        canViewContent
        canUploadContent
        canManageStructuredDocument
        canReorderStructuredDocument
        canEditContent
        canEditContentName
        canEditContentMetadata
        canEditOwnedContentMetadata
        canSendContentToTenancy
        canDeleteContentToTenancy
        canDeleteOwnedContent
        canDeleteQuestion
        canCreateQuestion
        canEditOwnedQuestion
        canEditQuestion
        canEditQuestionResponse
        canChangeOwnedQuestionStatus
        canChangeQuestionStatus
        canChangeQuestionResponseStatus
        canImportReferenceOrExternalQuestion
        canEditReferenceOrExternalQuestion
        canChangeReferenceOrExternalQuestionStatus
        canSendCopyQuestion
        canSubmitQuestionResponse
        canSubmitReferenceOrExternalQuestion
        canExportData
        canExportQuestionAndResponse
        canCreateOwnedCommentsAsset
        canCreateComments
        canResolveComments
        canCreateTask
        canCompleteTask
        canManageTask
        canManageOwnTask
        canViewAssignToAllParentTask
        canChangeContentStatus
        canSendHAInvitation
        canManageProjectInvitations
        canCreateProjectInvitations
        canManageMilestones
        canCreatePrivateInlineComment
        canCreatePeerInlineComment
        canCreatePublicInlineComment
        canResolveOwnInlineComments
        canResolveOthersInlineComments
        canChangeOwnedContentStatus
        canBeAssignedToTask
      }
    }
  `,
};
